import { defineHeroThemeContract, type HeroThemeTokens } from '../../../art/contract';

/**
 * The sprout hero's THEME (ADR-0099 / ADR-0102 / ADR-0117) — a warm leaf-green + terracotta + sunflower garden
 * palette pulled from her painted art, with a soft dawn-garden sky (her own world). Choosing her recolours the
 * WHOLE kid shell: the brand ramp drives buttons / meters / rings in leaf-green, the canvas blooms warm to a
 * green+gold morning, and the hero stage takes her sunrise-over-the-garden sky. Every brand colour is paired
 * with its own foreground for legibility.
 */
export const sproutTheme: HeroThemeTokens = defineHeroThemeContract({
  // BRAND RAMP — leaf-green. `soft`→`primary` is the button/meter gradient (white text); `deep` is on-light text
  // (≈ 7:1 on the light kid surfaces); `tint` is the softest fill; `glow-rgb` = #3C8438 for coloured shadows.
  '--color-primary': '#3C8438',
  '--color-primary-fg': '#FFFFFF',
  '--color-primary-soft': '#4AA643',
  '--color-primary-deep': '#2C5F29',
  '--color-primary-tint': '#E7F5E5',
  '--color-primary-glow-rgb': '60 132 56',
  '--color-secondary': '#F6E0D3',
  '--color-secondary-fg': '#7A3B22',
  '--color-accent': '#FFCF4D',
  '--color-accent-fg': '#4A3800',
  // CANVAS — a leaf-green bloom top-left, a soft-gold bloom bottom-right (a warm garden morning behind the content).
  '--canvas-a': '#E7F5E1',
  '--canvas-b': '#FCF1D6',
  // A soft terracotta-and-gold garden sunrise (white text stays AA over it).
  '--sky-top': '#2f5a3a',
  '--sky-mid': '#51804D',
  '--sky-low': '#e5a878',
  '--sky-glow': '#ffe6b0',
  '--sky-fg': '#ffffff',
});
